import { render } from "./DefinirRegrasUnidade.vue?vue&type=template&id=2316ddb6&scoped=true"
import script from "./DefinirRegrasUnidade.vue?vue&type=script&lang=js"
export * from "./DefinirRegrasUnidade.vue?vue&type=script&lang=js"

import "./DefinirRegrasUnidade.vue?vue&type=style&index=0&id=2316ddb6&lang=sass"
import "./DefinirRegrasUnidade.vue?vue&type=style&index=1&id=2316ddb6&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2316ddb6"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QTable,QInput,QSelect});
